import LoadingSpinner from "components/LoadingSpinner";
import PopupGiftTopup from "components/popup-gift-topup";
import PopupMessage from "components/popup-message";
import AppConfigs from "configs/env";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import actions from "redux/home/actions";
const VoucherPage = (props) => {
  const [nameBtn, setNameBtn] = useState("");
  const [nameBtn1, setNameBtn1] = useState("");
  const [nameBtn2, setNameBtn2] = useState("");
  const [modal, setModal] = useState(false);
  const [content, setContent] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isShowModalTopup, setIsShowModalTopup] = useState(false);
  const hideModal = () => {
    setModal(false);
    setContent("");
    setNameBtn("");
    setNameBtn1("");
    setNameBtn2("");
    document.body.classList.remove("modal-open");
  };
  const [listGifts, setListGifts] = useState([]);
  const [activeGift, setActiveGift] = useState("");
  const [groupBtnBlock, setGroupBtnBlock] = useState(false);

  const [isLoading, setIsLoading] = useState(true);
  const actionTypeRef = useRef("");

  const clickAction = () => {
    hideModal();
    navigate("/guide");
  };

  const getGifts = () => {
    dispatch(
      actions.GET_GIFT_SUMMARY.request(
        null,
        (res) => {
          const temp = res?.filter((elm) => elm?.remainingQuantity <= 0);
          if (temp.length === res?.length) {
            checkError("OUT_OF_STOCK_ALL_GIFT");
          }
          setListGifts(res);
          setIsLoading(false);
        },
        (err) => {
          setIsLoading(false);
        }
      )
    );
  };

  const clickActionError = () => {
    switch (actionTypeRef.current) {
      case "GO_TO_INFORMATION":
        navigate("/information");
        break;

      case "GO_TO_GUIDE":
        navigate("/guide");
        break;
      case "FETCH_GIFTS":
        getGifts();
        break;

      default:
        break;
    }
    hideModal();
  };

  useEffect(() => {
    const signature = localStorage.getItem("sjkhjk");
    if (!signature) {
      const code = localStorage.getItem("cghjfkhgj");
      const wish = localStorage.getItem("wish");
      if (code) {
        if (wish) {
          navigate("/information");
        } else {
          navigate("/");
        }
      } else {
        navigate("/guide");
      }
      return;
    }
    getGifts();
  }, []);

  const showModal = () => {
    setModal(true);
    document.body.classList.add("modal-open");
  };
  const checkError = (errCode) => {
    let content = "";
    switch (errCode) {
      case "OUT_OF_STOCK":
        content =
          "Ops, quà của bạn đang chọn hiện đã hết, vui lòng chọn những quà còn lại nhé";
        actionTypeRef.current = "FETCH_GIFTS";
        setNameBtn(`ĐÓNG`);
        break;

      case "CAMPAIGN_NOT_START_YET":
        content = `Chương trình chưa bắt đầu.
          Vui lòng quay trở lại vào ngày ${AppConfigs.startDate}`;
        actionTypeRef.current = "GO_TO_GUIDE";
        setNameBtn(`ĐÓNG`);
        break;

      case "CAMPAIGN_ENDED":
        content = `Chương trình đã kết thúc vào ngày ${AppConfigs.endDate}. Hẹn gặp lại bạn trong các chương trình sau nhé.`;
        setNameBtn(`ĐÓNG`);
        actionTypeRef.current = "GO_TO_GUIDE";
        break;

      case "EXCEEDED_GIFT_PER_USER":
        content = `Số điện thoại này đã nhận voucher trước đó. Vui lòng tham gia chương trình sau nhé.`;
        setNameBtn(`ĐÓNG`);
        break;

      case "DUPLICATE_REQUEST":
        content =
          "Yêu cầu gửi mã OTP của bạn đang được chúng tôi xử lý, bạn hãy thử lại sau 1 phút nhé";
        setNameBtn(`ĐÓNG`);
        break;

      case "EXCEEDED_GIFT_PER_USER":
        content =
          "Số điện thoại này đã nhận voucher trước đó. Vui lòng tham gia chương trình sau nhé.";
        setNameBtn(`ĐÓNG`);
        break;

      case "INVALID_SIGNATURE":
        actionTypeRef.current = "GO_TO_INFORMATION";
        localStorage.removeItem("sjkhjk");
        localStorage.removeItem("tjfsaj");
        content = `Đã hết thời gian chọn quà.<br/>Bạn vui lòng nhập lại thông tin`;
        setNameBtn(`ĐÓNG`);

        break;

      case "OUT_OF_STOCK_ALL_GIFT":
        content = `Chương trình đã kết thúc trước thời hạn do hết quà. Cảm ơn bạn đã quan tâm đến chương trình và tin dùng sản phẩm từ P/S.`;
        actionTypeRef.current = "GO_TO_GUIDE";
        localStorage.removeItem("sjkhjk");
        localStorage.removeItem("cghjfkhgj");
        localStorage.removeItem("tjfsaj");
        localStorage.removeItem("wish");
        setNameBtn(`ĐÓNG`);
        break;

      default:
        content = `Đã có lỗi xảy ra.<br/>
        Quý khách vui lòng thử lại sau.`;
        setNameBtn(`ĐÓNG`);
        break;
    }
    showModal();
    setContent(`${content}`);
  };

  const takeGift = () => {
    const signature = localStorage.getItem("sjkhjk");
    const code = localStorage.getItem("cghjfkhgj");
    const userName = localStorage.getItem("uoioioas");
    const phoneNumber = localStorage.getItem("phsjha");
    const timestamp = localStorage.getItem("tjfsaj");
    if (signature && code && userName && phoneNumber && timestamp) {
      const payload = {
        signature,
        code,
        userName,
        phoneNumber,
        giftId: activeGift,
        timestamp: parseInt(timestamp),
      };
      setIsLoading(true);
      dispatch(
        actions.TAKE_GIFT.request(
          payload,
          (res) => {
            setIsLoading(false);
            localStorage.removeItem("sjkhjk");
            localStorage.removeItem("cghjfkhgj");
            localStorage.removeItem("tjfsaj");
            localStorage.removeItem("wish");
            setIsShowModalTopup(true);
          },
          (err) => {
            setIsLoading(false);
            checkError(err?.data?.error?.code);
          }
        )
      );
    }
  };

  return (
    <>
      <div className="container">
        <img
          className="img-full"
          src="assets/img/Title-voucher.png"
          alt="line-bt"
        />
        <p className="note-voucher">Chọn 1 món quà mà bạn thích</p>
        <div className="list-voucher">
          {listGifts.map((elm) => {
            return (
              <div
                onClick={() => {
                  setActiveGift(elm.giftId);
                }}
                className={`voucher-item ${
                  elm.remainingQuantity <= 0 ? "disable" : ""
                } ${
                  elm.giftId === activeGift && elm.remainingQuantity > 0
                    ? "active"
                    : ""
                }`}
              >
                <p>
                  <span>{elm.giftName}</span> <br />
                  {elm.giftDescription}
                </p>
                <img className="img-full" src={elm.giftImage} alt="line-bt" />
              </div>
            );
          })}
        </div>
        <div className="btn-wrapper text-center">
          <button
            type="submit"
            className={`btn btn-primary btn-block ${
              activeGift.length > 0 ? "" : "disable"
            }`}
            onClick={() => takeGift()}
          >
            XÁC NHẬN QUÀ TẶNG
          </button>
        </div>
      </div>
      {isShowModalTopup && (
        <PopupGiftTopup
          phoneNumber={props?.phoneNumber}
          giftType={props?.rewardData}
          giftData={listGifts?.find((elm) => elm?.giftId === activeGift)}
          clickAction={clickAction}
        />
      )}

      {modal && (
        <PopupMessage
          nameBtn={nameBtn}
          nameBtn1={nameBtn1}
          nameBtn2={nameBtn2}
          setModal={setModal}
          content={content}
          groupBtnBlock={groupBtnBlock}
          clickAction={clickActionError}
          clickAction1={clickActionError}
          clickAction2={clickActionError}
          clickAction3={clickActionError}
          clickAction4={clickActionError}
        />
      )}
      <LoadingSpinner isLoading={isLoading} />
    </>
  );
};
export default VoucherPage;
